export default __webpack_public_path__ + "static/media/gift-1.6abe1035.svg";